import React from 'react';
import SmartImage from '../../ui/SmartImage';

const infoCards = [
    {
        number: '01',
        title: 'Peran Strategis',
        text: 'PT Len Telekomunikasi Indonesia memiliki peran strategis dalam menjaga kedaulatan negara serta membangun kesejahteraan masyarakat melalui penyediaan layanan telekomunikasi yang handal dan merata. Dengan proyek-proyek besar seperti Palapa Ring, PT Len Telekomunikasi Indonesia diakui sebagai salah satu pemain kunci dalam dunia telekomunikasi nasional. Proyek ini memungkinkan akses broadband yang lebih luas dan merata, terutama di daerah-daerah 3T (Terdepan, Terluar, dan Tertinggal), yang selama ini kesulitan mendapatkan akses telekomunikasi.',
    },
    {
        number: '02',
        title: 'Proyek Utama',
        text: 'Salah satu proyek utama PT Len Telekomunikasi Indonesia adalah Pembangunan dan Pengelolaan Jaringan Tulang Punggung Serat Optik Palapa Ring Paket Tengah. Proyek ini bertujuan untuk menyediakan infrastruktur yang mendukung percepatan ekonomi berbasis digital di seluruh Indonesia. Infrastruktur yang dibangun terdiri dari jaringan serat optik darat dan laut, yang tersebar di 17 kabupaten atau kota di wilayah Indonesia Bagian Tengah, dengan kabel laut sepanjang 1.825 km dan kabel darat 1.321 km.',
    },
    {
        number: '03',
        title: 'Dasar Hukum',
        text: 'Dasar hukum yang melandasi aktivitas PT Len Telekomunikasi Indonesia termasuk Perjanjian Kerjasama antara KOMINFO dengan Len Telekomunikasi Indonesia, dengan nomor: 286/M.KOMINFO/HK.03.03/02/2016 dan nomor: 001/PKS/DU/II/2016, tertanggal 4 Maret 2016. Perjanjian ini mengatur tentang pembangunan dan pengelolaan Jaringan Tulang Punggung Serat Optik Palapa Ring Paket Tengah. Dokumen ini menjadi dasar bagi PT Len Telekomunikasi Indonesia untuk melaksanakan seluruh kegiatannya terkait penyediaan layanan konektivitas nasional yang berkualitas.',
    },
];

const ProfilPerusahaan = () => (
    <div className="py-4 lg:py-6">
        <div className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-[0_22px_60px_rgba(15,23,42,0.08)]">
            <div className="grid lg:grid-cols-[1.05fr_0.95fr]">
                <div className="bg-gradient-to-br from-slate-950 via-[#0a213a] to-[#084b7c] p-7 text-white sm:p-9 lg:p-12">
                    <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-300">Profil Perusahaan</span>
                    <h2 className="mt-4 text-3xl font-bold leading-tight sm:text-4xl">Membangun konektivitas untuk pemerataan digital Indonesia</h2>
                    <p className="mt-6 text-base leading-8 text-slate-200 sm:text-lg">
                        PT Len Telekomunikasi Indonesia (PT Len Telekomunikasi Indonesia) adalah perusahaan yang bergerak dalam pembangunan infrastruktur telekomunikasi nasional, khususnya melalui proyek Palapa Ring Paket Tengah. Sebagai bagian dari Badan Usaha Pelaksana (BUP), PT Len Telekomunikasi Indonesia bertujuan untuk menyediakan konektivitas berkualitas bagi seluruh wilayah Indonesia.
                    </p>
                    <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
                        {[
                            ['2016', 'Awal proyek'],
                            ['17', 'Kab/Kota'],
                            ['3T', 'Fokus konektivitas'],
                        ].map(([value, label]) => (
                            <div key={label} className="rounded-2xl border border-white/10 bg-white/[0.06] p-4 backdrop-blur-sm">
                                <div className="text-2xl font-bold text-white">{value}</div>
                                <div className="mt-1 text-xs text-slate-300">{label}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="flex items-center bg-slate-50 p-5 sm:p-8">
                    <SmartImage
                        src="/assets-web/skema_bisnis.png"
                        alt="Skema Bisnis PT Len Telekomunikasi Indonesia"
                        wrapperClassName="w-full rounded-2xl border border-slate-200 bg-white p-2 shadow-sm"
                        className="h-auto w-full object-contain"
                    />
                </div>
            </div>
        </div>

        <div className="mt-7 grid gap-5 lg:grid-cols-3">
            {infoCards.map((item) => (
                <article key={item.title} className="rounded-[26px] border border-slate-200 bg-white p-6 shadow-[0_16px_42px_rgba(15,23,42,0.06)]">
                    <div className="flex items-center justify-between">
                        <h3 className="text-xl font-bold text-slate-950">{item.title}</h3>
                        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-blue-50 text-[11px] font-bold text-blue-700">{item.number}</span>
                    </div>
                    <p className="mt-4 text-sm leading-7 text-slate-600 sm:text-base">{item.text}</p>
                </article>
            ))}
        </div>
    </div>
);

export default ProfilPerusahaan;
